export const getTheoreticalPartStatusColor = (item) => {
  return item.complete ? 'success' : 'inverse';
};